import { Component } from '@angular/core';

@Component({
  selector: 'app-client-custom-widget-layout',
  templateUrl: './custom-widget-layout.component.html',
  styleUrls: ['../taiao-dashboard-layout/taiao-dashboard-layout.component.scss'],
})
export class default_CustomWidgetLayoutComponent {}
